import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';

const GlobalSummary = props => {
  const { t, data, showModal } = props;

  const {
    isActive,
    activeUntilDate,
    totalAmountInvested,
    nextAmountInvestmentsLevel,
    nextInvestmentsLevelName,
    weeklyCapping,
    currencyInfo,
  } = data;

  const amountNeeded = nextAmountInvestmentsLevel - totalAmountInvested;

  return (
    <div className="grid-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
      <div className="grid-item">
        <div className="card card-light-gray">
          <div className="summary-card">
            <div className="summary-media">
              <img
                src="/images/reports/user-summary.svg"
                alt="active"
                className="summary-image"
              />
            </div>
            <div className="summary-content">
              <div className="summary-section">
                <span className="summary-name">
                  {t('report.arcova.summary')}
                </span>
              </div>
              <div className="summary-action">
                <div className="summary-action-content">
                  <span className="summary-action-label">
                    {t('report.arcova.status')}
                  </span>
                  <label htmlFor="isActive" className="checkbox">
                    <input
                      name="isActive"
                      type="checkbox"
                      className="summary-checkbox"
                      disabled
                      checked={isActive}
                    />
                    <label htmlFor="isActive" className="fakeCheckbox" />
                    <span className="isActiveLabel">
                      {t('report.arcova.isActive')}
                    </span>
                  </label>
                </div>
                <div className="summary-action-content">
                  <span className="summary-action-label">
                    {t('report.arcova.activeUntil')}
                  </span>
                  <span className="summaryDate">
                    {moment(activeUntilDate).format('DD MMMM YYYY')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="card investment-levels">
          <div className="investment-totals">
            <div className="d-flex">
              <div className="small-image-container">
                <img
                  src="/images/reports/money-bag.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <span className="value-label">
                {t('report.arcova.totalAmountInvested')}
              </span>
            </div>
            <span className="card-main-value">
              {newFormatPrice(totalAmountInvested, true, currencyInfo.code)}
            </span>
            <button type="button" onClick={showModal} className="see-details">
              {t('report.arcova.seeDetails')}
            </button>
          </div>
          <div className="missing-value-card">
            <span className="small-text">{t('report.arcova.itIsMissing')}</span>
            <span className="bigger-text">
              {newFormatPrice(amountNeeded, true, currencyInfo.code)}
            </span>
            <span className="small-text">{t('report.arcova.nextLevel')}</span>
          </div>
        </div>
      </div>
      <div className="grid-item">
        <div className="card card-light-gray weekly-cap-card">
          <div className="card-body">
            <div className="d-flex">
              <div className="small-image-container">
                <img
                  src="/images/reports/calendar.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <span className="value-label weekly-capping">
                {t('report.arcova.weeklyCapping')}
              </span>
            </div>
            <span className="card-main-value">{`${newFormatPrice(
              weeklyCapping,
              true,
              currencyInfo.code,
            )}/${t('report.arcova.perWeek')}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    isActive: PropTypes.bool,
    activeUntilDate: PropTypes.string,
    totalAmountInvested: PropTypes.number,
    nextAmountInvestmentsLevel: PropTypes.number,
    nextInvestmentsLevelName: PropTypes.string,
    weeklyCapping: PropTypes.number,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
  }).isRequired,
  showModal: PropTypes.func.isRequired,
};

export default translate(GlobalSummary);
